import { addParams } from "@/utils/stringHelper";
import { ApiEnum } from "./api-enum";
import { BaseRequest } from "./core/base-request";
import type {
  ActivatePaymentOptions,
  BaseResponse,
  IActivatePaymentResponse,
  IPublisherStats,
  IUpdatePaymentPricesResponse,
  SetupUsernameOptions,
  UpdatePaymentPricesOptions,
  UpdateProfileOptions,
  UpdatePublisherEmailsOptions,
} from "./types";

export class PublisherService extends BaseRequest {
  public static async setupUsername(options: SetupUsernameOptions): Promise<BaseResponse<null>> {
    return PublisherService._post<null>(
      ApiEnum.SetupUsername,
      { username: options.username },
      { requiredAuth: true, mapperKey: ApiEnum.SetupUsername },
    );
  }

  public static async updateProfile(options: UpdateProfileOptions): Promise<BaseResponse<null>> {
    return PublisherService._post<null>(ApiEnum.UpdateProfile, options, { requiredAuth: true, mapperKey: ApiEnum.UpdateProfile });
  }

  public static async updateEmails(options: UpdatePublisherEmailsOptions): Promise<BaseResponse<null>> {
    return PublisherService._post<null>(ApiEnum.UpdateProfile, options, { requiredAuth: true, mapperKey: ApiEnum.UpdateProfile });
  }

  public static async deactivate(site: string): Promise<BaseResponse<null>> {
    return PublisherService._post<null>(
      ApiEnum.DeactivatePublisher,
      { site },
      { requiredAuth: true, mapperKey: ApiEnum.DeactivatePublisher },
    );
  }

  public static async activate(site: string): Promise<BaseResponse<null>> {
    return PublisherService._post<null>(ApiEnum.ActivatePublisher, { site }, { requiredAuth: true, mapperKey: ApiEnum.ActivatePublisher });
  }

  public static async deletePublisher(site: string): Promise<BaseResponse<null>> {
    return PublisherService._post<null>(
      ApiEnum.DeletePublisher,
      { site, username: site },
      { requiredAuth: true, mapperKey: ApiEnum.DeletePublisher },
    );
  }

  public static async getStats(site: string, days?: number): Promise<BaseResponse<IPublisherStats>> {
    const url = addParams(ApiEnum.GetStats, days ? { site, days } : { site });
    return PublisherService._get<IPublisherStats>(url, {}, { requiredAuth: true, mapperKey: ApiEnum.GetStats });
  }

  public static async activatePayment(options: ActivatePaymentOptions): Promise<BaseResponse<IActivatePaymentResponse>> {
    return PublisherService._post<IActivatePaymentResponse>(ApiEnum.ActivatePayment, options, {
      requiredAuth: true,
      mapperKey: ApiEnum.ActivatePayment,
    });
  }

  public static async deactivatePayment(site: string): Promise<BaseResponse<IActivatePaymentResponse>> {
    return PublisherService._post<IActivatePaymentResponse>(
      ApiEnum.DeactivatePayment,
      { site },
      { requiredAuth: true, mapperKey: ApiEnum.DeactivatePayment },
    );
  }

  public static async updatePaymentPrices(options: UpdatePaymentPricesOptions): Promise<BaseResponse<IUpdatePaymentPricesResponse>> {
    return PublisherService._post<IUpdatePaymentPricesResponse>(ApiEnum.UpdatePaymentPrices, options, {
      requiredAuth: true,
      mapperKey: ApiEnum.UpdatePaymentPrices,
    });
  }
}
